import React from 'react';
import { Flex, Box, Divider, useMediaQuery } from '@chakra-ui/react';
import ShoppingCart from '@view/components/Cards/ShoppingCart';
import MobileShoppingCart from '@view/components/Cards/ShoppingCart/mobile';
import ScreenSize from '../../constants/screen-sizes';

const DemoShoppingCart = () => {
  const [isMobile] = useMediaQuery(`(max-width: ${ScreenSize.MOBILE_LARGE})`);

  return (
    <Box>
      <h2>Shopping Cart</h2>
      <Divider m={2} />
      <Flex direction="column" align={'center'} gap={2}>
        {!isMobile && <ShoppingCart />}
        {isMobile && <MobileShoppingCart />}
      </Flex>
    </Box>
  );
};

export default DemoShoppingCart;
